import React, { PureComponent } from "react";
import fieldPropTypes from "./field-prop-types";
import { MessagingContext } from "../context/messaging-layer";

const Options = ({
  options,
  selectedCheck,
  components: { Radio },
  onChange,
  fieldsName
}) => {
  return options
    .filter(option => option.text)
    .map((option, index) => (
      <Radio
        key={option.text}
        label={option.text}
        value={option.text}
        name={option.name}
        index={index}
        fieldsName={fieldsName}
        onChange={() => onChange(option)}
        onKeyPress={e => {
          if (e.key === "Enter") {
            e.currentTarget.checked = true;
            onChange(option, selectedCheck);
          }
        }}
      />
    ));
};

const optionIsCheckedState = option => option.text !== "";

export default class CellWithCheckField extends PureComponent {
  getValue(option) {
    const {
      field: { name, params }
    } = this.props;
    let altOption;
    if (params.includes("TDFieldOptionIncludesOptions")) {
      altOption = option.value;
    } else {
      altOption = option.text;
    }
    return {
      [name]: option.value,
      [this.textName()]: altOption
    };
  }

  handleControlCheck = () => {
    const {
      field: { options, title, placeholder, name },
      components,
      appData: { handleChange, settings }
    } = this.props;

    if (this.multipleOptions()) {
      const selectedOption = options.find(o => this.optionIsSelected(o));
      const activeElement = document.activeElement;

      if (!selectedOption || !optionIsCheckedState(selectedOption)) {
        this.context.showDialog({
          actions: [
            {
              label: settings.translations.cancel,
              className: "secondary",
              name: "close-dialog",
              onClick: () => this.uncheckCell()
            }
          ],
          content: {
            title: placeholder?.replace("%@", title.toLowerCase()),
            children: (
              <div data-testid={`cell-with-check-${name}`}>
                <Options
                  fieldsName={name}
                  options={options}
                  components={components}
                  onChange={this.handleOptionCheck}
                  selectedCheck={activeElement}
                />
              </div>
            )
          }
        });
      } else {
        this.uncheckCell();
      }
    } else {
      const unselectedOption = options.find(o => !this.optionIsSelected(o));
      handleChange(this.getValue(unselectedOption));
    }
  };

  handleOptionCheck = (option, selectedCheck) => {
    this.props.appData.handleChange(this.getValue(option));
    setTimeout(this.context.hideDialog, 100); // to allow browser to paint chosen option

    // Restore focus to selected checkbox
    selectedCheck?.focus();
  };

  multipleOptions = () => {
    const {
      field: { params }
    } = this.props;
    return (
      params.includes("TDFieldOptionIsFamilyHistory") ||
      params.includes("TDFieldOptionIncludesOptions")
    );
  };

  textName(name) {
    return (name ?? this.props.field.name).replace("_id", "");
  }

  optionIsSelected(option) {
    const {
      field: { name, params },
      appData: { values }
    } = this.props;
    return (
      option.value === values[name] &&
      (params.includes("TDFieldOptionIncludesOptions")
        ? option.value
        : option.text) === values[this.textName()]
    );
  }

  uncheckCell() {
    const {
      field: { options },
      appData: { handleChange }
    } = this.props;

    handleChange(this.getValue(options.find(o => !optionIsCheckedState(o))));
  }

  render() {
    const {
      field: { options, title, name },
      components: { CellWithCheck }
    } = this.props;
    const selectedOption = options.find(o => this.optionIsSelected(o));
    const label = [title];
    let ariaLabel = title;
    if (this.multipleOptions() && selectedOption?.text) {
      ariaLabel += `, ${selectedOption.text}`;
      label.push(<br key={title} />);
      label.push(<span key={name}>{selectedOption.text}</span>);
    }
    return (
      <CellWithCheck
        name={name}
        label={label}
        ariaLabel={ariaLabel}
        handleControlCheck={this.handleControlCheck}
        checked={selectedOption && optionIsCheckedState(selectedOption)}
      />
    );
  }
}

CellWithCheckField.propTypes = fieldPropTypes;
CellWithCheckField.contextType = MessagingContext;
